// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24SgU","option":"styles_option__2jY77","active":"styles_active__2HRRh"};